
import { Component, Vue, Inject, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Switch from '@/components/switch.vue';
import UploadImg from '@/components/upload-img.vue';
import selectProducts from '@/components/selectProducts.vue';
import ChoosePages from '@/components/choosepages/choosepages.vue';
import vuedraggable from 'vuedraggable';
import {
	imgHost
} from "@/utils/config"
@Component({
	name: '',
	components: {
		PageFooter,
		UploadImg,
		selectProducts,
		ChoosePages,
		vuedraggable,
		'slz-switch': Switch,
	}
})

export default class ProductList extends Vue {

	@Inject() information: any
	get value() {
		return this.information
	}
	@Inject() editinfo: any
	get editmsg() {
		return this.editinfo.msg
	}

	private productCount = 0;
	private areaCount = 0;

	private imgHost = imgHost;
	private productVisible = false;
	private products = [];
	private productType = 1;
	private itemIndex = 0;
	private selectDate = '';
	private defaultValue = '';

	private chooseLinkVisible = false;
	private momentsel = -1;
	private choosemsg: any = {};

	private inputVisible = false;
	private inputValue = '';

	@Watch('editmsg.dateType')
	private dateTypeChange(e) {
		this.list = this.editmsg.someDayData[this.dateTabs[this.editmsg.dateType - 1].date] || [];
	}

	@Watch('list', { deep: true })
	private listChange(e) {

		this.editmsg.someDayData[this.dateTabs[this.editmsg.dateType - 1].date] = this.list;

		let count1 = 0;
		let count2 = 0;
		this.list.map(item => {
			if (item.type === 1) {
				count1++;
			} else {
				count2++;
			}
		})
		this.productCount = count1;
		this.areaCount = count2;
	}

	private dateTabs = [];
	private list = [];

	private created() {
		this.getDates();
		let dt = this.editmsg.someDayData;
		let obj = {};
		this.dateTabs.map(item => {
			obj[item.date] = dt[item.date] || [];
		})

		this.editmsg.someDayData = obj;

		this.list = this.editmsg.someDayData[this.dateTabs[this.editmsg.dateType - 1].date] || [];

	}
	private getDates() {
		const today = new Date();
		const theDayBeforeYesterday = new Date(today.getTime() - 1000 * 60 * 60 * 24 * 2);
		const yesterday = new Date(today.getTime() - 1000 * 60 * 60 * 24);
		const tomorrow = new Date(today.getTime() + 1000 * 60 * 60 * 24);
		this.defaultValue = this.formatDate(today).date + ' 00:00:00';

		this.dateTabs = [
			{
				id: 1,
				...this.formatDate(theDayBeforeYesterday),
			}, {
				id: 2,
				...this.formatDate(yesterday)
			}, {
				id: 3,
				...this.formatDate(today)
			}, {
				id: 4,
				...this.formatDate(tomorrow)
			}
		]
	}
	private formatDate(dt) {
		let year = dt.getFullYear();
		let month = dt.getMonth() + 1;
		let day = dt.getDate();
		month = month > 9 ? month : ('0' + month);
		day = day > 9 ? day : ('0' + day);
		return {
			text: `${month}月${day}日`,
			date: `${year}-${month}-${day}`
		};
	}

	private async uploadSuccess(list, index, key) {
		let imgUrlInfo: any = await this.getImageWidthAndHeight(list[0]);
		this.list[index][key] = list[0];
		if (key == 'picture1') {
			this.list[index]['picture1Width'] = imgUrlInfo.width;
			this.list[index]['picture1Height'] = imgUrlInfo.height;
		}
	}
	private getImageWidthAndHeight(url) {
		return new Promise((resolve, reject) => {
			let imageUrl = this.imgHost + url;
			let image = new Image();
			image.onload = function () {
				resolve({
					width: image.width,
					height: image.height
				});
			}
			image.onerror = function () {
				resolve({
					width: 0,
					height: 0
				});
			}
			image.src = imageUrl;
		})

	}
	private handleDeleteItem(index) {
		this.list.splice(index, 1)
	}
	private handleChooseProduct() {
		let list = this.list.filter(item => {
			return item.type === 1;
		})
		this.products = list;
		this.selectDate = this.dateTabs[this.editmsg.dateType - 1].date;
		this.productVisible = true;
		this.productType = 1;
	}
	private handleSelectedProducts(list) {
		list.sort((a, b) => {
			return b.Id - a.Id;
		})
		list.sort((a, b) => {
			return b.Sort - a.Sort;
		})
		list.map(item => {
			item.type = 1;
			
			const p = this.products.filter(obj=>{
				return obj.Id === item.Id
			})
			if (p.length){
				item.tag = p[0].tag || '';
			}else{
				item.tag = ''
			}
			
			return item;
		})

		if (this.productType == 1) {
			this.list.push(...list);
		} else {
			this.list[this.itemIndex].products.push(...list);
		}

		this.productVisible = false;
	}
	private handleAddAreaData() {
		this.list.push(
			{
				type: 2,
				areaName: '',
				areaDesc: '',
				tag: '',
				link: {},
				products: [],
				start: '',
				end: '',
				picture1: '',
				picture2: '',
				picture1Width: 0,
				picture1Height: 0,
				expaned: false,
				tags: []
			}
		)
	}
	private handleAddAreaProduct(index) {
		this.products = this.list[index].products;
		this.selectDate = this.dateTabs[this.editmsg.dateType - 1].date;
		this.productVisible = true;
		this.productType = 2;
		this.itemIndex = index;
	}
	private handleClearProduct(i, j) {
		this.list[i].products.splice(j, 1)
	}

	private choosepage(index) {
		this.momentsel = index;
		this.choosemsg = this.list[index].link;
		this.chooseLinkVisible = true;
	}
	private handleSelectedLink(e) {
		this.chooseLinkVisible = false;
		this.list[this.momentsel].link = e;
	}
	private handleClearLink(index) {
		this.list[index].link = {};
	}


	private handleDeleteTag(listIndex, tagIndex) {
		this.list[listIndex].tags.splice(tagIndex, 1);
	}
	private showInput(key) {
		this.inputVisible = true;
		this.$nextTick(_ => {
			this.$refs[key][0].$refs.input.focus()
		});
	}

	private handleInputConfirm(index) {
		let inputValue = this.inputValue;
		if (inputValue) {
			this.list[index].tags.push(inputValue);
		}
		this.inputVisible = false;
		this.inputValue = '';
	}
}
